// src/contenfulService.js
import { createClient } from 'contentful';

// read your two env vars — CRA will inline these at build time
const spaceId   = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const accessToken = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;

// sanity‑check at startup
if (!spaceId) {
  throw new Error(
    'Missing REACT_APP_CONTENTFUL_SPACE_ID — ' +
    'make sure you set it in Netlify UI (and in your local .env) and restart the build.'
  );
}
if (!accessToken) {
  throw new Error(
    'Missing REACT_APP_CONTENTFUL_ACCESS_TOKEN — ' +
    'make sure you set it in Netlify UI (and in your local .env) and restart the build.'
  );
}

// instantiate your client once
const client = createClient({
  space: spaceId,
  environment: 'master',  // or your chosen environment
  accessToken: accessToken,
});

/**
 * Fetch a single entry by ID.
 * @param {string} entryId
 * @returns {Promise<ContentfulEntry>}
 */
export function fetchEntry(entryId) {
  return client.getEntry(entryId);
}

/**
 * Fetch a list of entries matching your query.
 * @param {object} query  Contentful query object
 * @returns {Promise<ContentfulEntries>}
 */
export function fetchEntries(query) {
  return client.getEntries(query);
}
